module.exports = __webpack_public_path__ + "media/components/src/assets/images/shopping_cart/shopping_cart_white_24dp-ae113c835acd174f5c60385fdf2f8dbf.svg";